import { MONTHS } from 'Data/constants.js'
import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data'
import { getMonth } from 'date-fns'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  /** @type {Date | undefined} */
  let sidebar_date = useDataValue({
    context: 'sidebar',
    viewPath: props.viewPath,
    path: 'date',
  })

  return useMemo(() => {
    return {
      months: MONTHS.map(month => ({
        ...month,
        selected: sidebar_date ? month.id === getMonth(sidebar_date) : false,
      })),
      date: sidebar_date,
    }
  }, [sidebar_date])
}
